<template>
    <b-form-checkbox
        inline
        switch
        size="lg"
        v-model="modelForm[modelName]"
        :value="checkedValue"
        :unchecked-value="uncheckedValue"
        :disabled="isDisabled"
        @input="doAction"
    />
</template>

<script>
export default {
    name: "CheckBox",
    props: {
        modelForm: {
            type: Object,
            required: true,
        },
        modelName: {
            type: String,
            required: true,
        },
        checkedValue: {
            default: true,
        },

        // optional
        uncheckedValue: {
            default: false,
        },
        doAction: {
            type: Function,
            default: function () {
            },
        },
        isDisabled: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>

</style>